import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 10px;
    border-radius: 10px;
    padding-block: 5px;
    background: ${({$background})=> ($background ? '#fff' : '#F2F2F2')};
`;

export const OutButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 7px;
    width: 30px;
    height: 30px;
    border-radius: 15px;
    color: #FF3939;
    border: 0.743px solid #FF3939;
    background: transparent;
    font-weight: 900;
    line-height: normal;
    cursor: pointer;
    outline: none;
    transition: 1s;
    &:hover {
        background: #FF3939;
        color: #fff;
    }
`;

export const NameContainer = styled.div`
    display: flex;
    align-items: center;
    width: 55%;
`;

export const ValuesContainer = styled.div`
    display: flex;
    align-items: center;
    width: 50px;
`;

export const ArrowContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
`;

export const ArrowIMG = styled.img`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const NameText = styled.span`
    color: #333;
    leading-trim: both;
    text-edge: cap;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`;

export const OldValueText = styled.span`
    color: #3C9;
    leading-trim: both;
    text-edge: cap;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`;

export const NewValueText = styled.span`
    color: #3C9;
    leading-trim: both;
    text-edge: cap;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    overflow: auto;
    &::-webkit-scrollbar {
        height : 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
`;

export const StateContainer = styled.span`
    background-color: ${props => (props.$state ? '#3C3' : '#FF3939')};
    border-radius: 50%;
    width: 20px;
    height: 20px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #F6F6F6;
    text-align: center;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: 8.743px;
    cursor: pointer;
    box-shadow: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
`;

export const ModeContainer = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #3C3;
    border: none;
    cursor: pointer;
    width: 21px;
    height: 21px;
    text-align: center;
    border-radius: 50%;
    transition: background-color 0.3s;
    box-shadow: none;
    user-select: none;
    outline: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
    color: #F6F6F6;
    font-size: 14.974px;
    font-style: normal;
    font-weight: 700;
    line-height: 8.728px; /* 58.29% */
`